import { all, fork } from "redux-saga/effects";
import {
  watchLoginSaga,
  watchRegisterSaga,
  watchGetProfileSaga,
  watchUpdateProfileSaga,
} from "./authSaga";
import {
  watchGetSuppliersSaga,
  watchGetSupplierSaga,
  watchCreateSupplierSaga,
  watchUpdateSupplierSaga,
  watchDeleteSupplierSaga,
  watchGetSupplierStatsSaga,
} from "./supplierSaga";
import {
  watchGetStockItemsSaga,
  watchGetStockItemSaga,
  watchCreateStockItemSaga,
  watchUpdateStockItemSaga,
  watchUpdateStockQuantitySaga,
  watchDeleteStockItemSaga,
  watchGetStockAlertsSaga,
  watchGetStockStatsSaga,
} from "./stockSaga";
import { billingSaga } from "./billingSaga";

export default function* rootSaga() {
  yield all([
    // Auth sagas
    fork(watchLoginSaga),
    fork(watchRegisterSaga),
    fork(watchGetProfileSaga),
    fork(watchUpdateProfileSaga),

    // Supplier sagas
    fork(watchGetSuppliersSaga),
    fork(watchGetSupplierSaga),
    fork(watchCreateSupplierSaga),
    fork(watchUpdateSupplierSaga),
    fork(watchDeleteSupplierSaga),
    fork(watchGetSupplierStatsSaga),

    // Stock sagas
    fork(watchGetStockItemsSaga),
    fork(watchGetStockItemSaga),
    fork(watchCreateStockItemSaga),
    fork(watchUpdateStockItemSaga),
    fork(watchUpdateStockQuantitySaga),
    fork(watchDeleteStockItemSaga),
    fork(watchGetStockAlertsSaga),
    fork(watchGetStockStatsSaga),

    // Billing saga
    fork(billingSaga),
  ]);
}
